<div class="footer">
  <div class="footer-container">
    <nav class="footer-links" aria-label="Footer Navigation">
      <a class="footer-link" routerLink="/impressum">Impressum</a>
      <a class="footer-link" routerLink="/datenschutz">Datenschutz</a>
      <a class="footer-link" routerLink="/downloads">AGB</a>
      <a class="footer-link" routerLink="/kuendigung">Kündigung</a>
    </nav>

    <div class="footer-logo">
      <img src="assets/images/icons/footer_logo.svg" alt="Inexio Logo mit dem Zusatz „Ein Unternehmen der inexio GmbH“" />
    </div>
  </div>
</div>
